import { setStoredItem, getStoredItem, clearStoredItem } from '../stored-item'
import Config from '../../config'
import axios from 'axios'
import { createUuid, getUS } from '../../modules/uuid'
import userSession from '../../topics/Profile/modules/user-session'

/**
 * this function will always be called after the user logs in succesfully.
 * @param user
 * @param callBackAfterLogin
 */
const login = (user, callBackAfterLogin) => {
  setStoredItem('user', JSON.stringify(user))
  callBackAfterLogin && callBackAfterLogin()
}

const uuid = createUuid()
const s = uuid + 'pm97cLnLIdqI0GueUozSUZexw1iNZ5WEfVqYz5uX7PGw'

/**
 * a function which can be called if you want to log the user in automatically.
 * Client Secret is stored in 1Password as client_secret_stol_react.
 * This might not work on the local testsystem because of a cross origin policy.
 */
const automaticLogin = () => {
  //get user with the existing access_token and automatically log him in
  userSession.getAccessToken() !== null &&
    getStoredItem('user') === null &&
    axios
      .get(Config.restUrl('user'), {
        headers: {
          Authorization: 'Bearer ' + userSession.getAccessToken(),
          Accept: 'application/json',
        },
      })
      .then((response) => {
        login(response.data)
      })
      .catch((error) => {
        //refreshing access_token
        clearStoredItem('user')
        clearStoredItem('access_token', true)
        clearStoredItem('access_token_expires_in', true)
        if (error && error.response && error.response.data && error.response.data.error === 'invalid_token') {
          axios
            .post(
              Config.authUrl('token'),
              'scope=*&client_id=1&client_secret=' +
                getUS(s, uuid) +
                '&refresh_token=' +
                getStoredItem('refresh_token', true),
              {
                headers: {
                  Accept: 'application/json',
                },
              },
            )
            .then((response) => {
              if (response.data.access_token) {
                setStoredItem('access_token', response.data.access_token, true)
                setStoredItem('access_token_expires_in', response.data.expires_in, true)
                setStoredItem('refresh_token', response.data.refresh_token, true)
              }
            })
        }
      })
}

export { login, automaticLogin }
